import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import type { InterpretiveReportDto } from '../../../hooks/queries/useGetInterpretiveReportQuery';
import { sectionNumber } from '../interpretiveReportView';
import { SectionHead } from './SectionHead';
import styles from '../InterpretiveReportPage.module.css';

type ConversationStartersProps = {
  number: string;
  prompts: InterpretiveReportDto['conversationPrompts'];
};

export const ConversationStarters = ({ number, prompts }: ConversationStartersProps) => {
  const { t } = useTranslation();
  return (
    <section>
      <SectionHead
        number={number}
        eyebrow={t('interpretiveReport.document.conversations.eyebrow')}
        title={t('interpretiveReport.document.conversations.title')}
        intro={t('interpretiveReport.document.conversations.intro')}
      />
      <ol className={styles.prompts}>
        {prompts.map((prompt, index) => (
          <li key={prompt.sequenceNumber} className={cn(styles.prompt, styles.keep)}>
            <span className={styles.promptNumber}>{sectionNumber(index)}</span>
            <span className={styles.promptText}>
              <span className={styles.promptQuestion}>{prompt.question}</span>
              <span className={styles.promptPurpose}>{prompt.purpose}</span>
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
};
